"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const application_config_1 = __importDefault(require("../../config/application.config"));
const RegisterForm_1 = __importDefault(require("../forms/auth/localLogin/RegisterForm"));
const RegisterPage = ({ config }) => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    const isAuthenticated = (0, react_redux_1.useSelector)((state) => state.auth.isAuthenticated);
    // Check if registration is allowed based on config
    const allowRegistration = react_1.default.useMemo(() => { var _a, _b; return config.allowRegistration !== false && ((_b = (_a = config.auth) === null || _a === void 0 ? void 0 : _a.localLogin) === null || _b === void 0 ? void 0 : _b.allowRegistration) !== false; }, [config]);
    // Handle email-only registration configuration
    const withEmailOnly = react_1.default.useMemo(() => { var _a, _b; return config.registerWithEmailOnly || ((_b = (_a = config.auth) === null || _a === void 0 ? void 0 : _a.localLogin) === null || _b === void 0 ? void 0 : _b.registerWithEmailOnly); }, [config]);
    // Redirect if authenticated
    if (isAuthenticated) {
        return react_1.default.createElement(react_router_1.Navigate, { to: application_config_1.default.homePage, replace: true });
    }
    // Return null if registration is not allowed
    if (!allowRegistration) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(RegisterForm_1.default, { withCaptcha: true, withEmailOnly: withEmailOnly }),
        react_1.default.createElement("div", { className: "apptr__separator-medium" }),
        react_1.default.createElement("div", { className: "apptr__footer-link-container" },
            react_1.default.createElement(react_router_1.Link, { className: "apptr__footer-link", to: "/login" }, t('auth:iAlreadyHaveAnAccount')))));
};
exports.default = RegisterPage;
//# sourceMappingURL=RegisterPage.js.map